function Plan(props) {


    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">경영</h4>
                <h5 className="recruit_titleline_title">기획</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                기획 직무는 전사의 경영을 기획하고 이를 관리하는 것입니다. 구체적으로 매년 회사의 경영계획 및 사업계획을 수립하고, 성과에 대한 점검을 진행하고 있습니다. 이러한 과정은 관리회계를 기반으로 하며, 매월 손익실적을 관리하고 추정하여 회사의 경영계획 및 사업계획 달성을<br />
                목표로 하고 있습니다.<br /><br />

                이러한 기획 직무를 수행하기 위해서는 우선 꼼꼼하게 숫자를 보고, 의미를 제대로 분석해내는 능력이 제일 필요하다고 생각합니다.<br />
                회사의 수익, 비용 등에 대해 검토하고 분석하는 것이 모든 업무의 바탕이 되기 때문입니다.<br /><br />

                그 다음으로는 논리적 사고와 이를 효과적으로 전달할 수 있는 커뮤니케이션 역량이 필요하다고 생각합니다. 기획팀에서 근무하면 다양한 현업부서와 예산 및 사안에 대해 커뮤니케이션 할 일이 생기는데, 해당 사안에 대해 논리적으로 사고하여 핵심을 파악하고, 회사의 이익이<br />
                극대화되는 방향으로 조정할 수 있는 효율적인 커뮤니케이션이 필요합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                위에서 소개한 기획 직무를 바탕으로 기획팀에서 하는 업무는 아래와 같습니다.
                </p>
                <em className="recruit_bold_text">연간 경영계획 수립 및 예산 관리 </em>
                <p className="recruit_subinfo_text">
                경영계획에 따른 예산을 수립하고, 관리회계 기준에 따라 실적을 집계 및 분석하여 예산을 관리합니다.
                </p>
                <em className="recruit_bold_text">연간 사업계획 수립 및 성과점검</em>
                <p className="recruit_subinfo_text">
                본부/팀 단위의 사업 목표를 확정하고 반기, 연간 성과점검을 진행합니다.
                </p>
                <em className="recruit_bold_text">자회사/계열회사 관리</em>
                <p className="recruit_subinfo_text">
                스튜디오S, 스튜디오 프리즘 등의 자회사 및 계열회사의 연간 경영목표 및 사업계획을 수립하고 관리합니다.
                </p>
                <em className="recruit_bold_text">이사회/사규</em>
                <p className="recruit_subinfo_text">
                회사의 주요 안건에 관해 의사결정을 하는 이사회 업무를 주관하고, 사내 제도를 담고 있는 사규의 제정 및 개정 등을 담당합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                기획팀에서 미디어사업, 광고/마케팅, 프로그램 제작 등 현업부서들의 예산 및 사업계획 등을 점검하다 보면, 해당 부서의 주요한 업무와 <br />
                수익 및 비용 구조에 대해서 파악하고 있기 때문에 어느 부서에 가더라도 환영 받을 수 있고 제 몫을 해낼 수 있을 것이라 생각합니다. <br />
                또한 기획팀과 유관부서인 재무팀, 미디어전략팀에서도 업무 역량을 충분히 발휘할 수 있습니다.<br />
                이러한 경험들을 바탕으로 미디어산업 밸류체인 전반에 대한 이해도가 높아질 것이고, 향후 회사 내 유능한 관리자의 커리어패스를 <br />
                이어 나갈 수 있을 것이라 생각합니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                안녕하세요. 저는 SBS 기획팀에서 근무하고 있는 박민우라고 합니다. <br />
                2016년도말에 입사하여 첫 부서로 기획팀에서 3년 동안 근무하였고, 이후 인사팀으로 발령 받아 4년 동안 근무를 하다가 다시 기획팀으로 <br />
                돌아오게 되었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">기획팀 업무를 하게 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                인턴으로 입사하여 여러 부서를 경험하면서, 학교 다니면서 재미있게 들었던 경영학 수업 내용과 기획팀에서 하는 업무가 연결되는 부분이 <br />
                많아서 기획팀에 관심이 생겼습니다.<br />
                경영학 수업을 들으면서 여러 기업들에 대해 다양한 분석을 통해서 기업이 지속적으로 이익을 내기 위한 방법이 무엇이 있을까 고민하는 <br />
                과정들이 재미있었는데, 기획팀에서도 업무를 하며 팀원들과 이러한 고민들을 함께 하는게 매번 어렵기도 하지만, 흥미롭기도 하여 <br />
                다시 기획팀으로 돌아오게 되었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                신입사원 시절에는 이사회 업무를 담당하며, 회사의 주요한 의사결정들이 어떤 과정을 통해 논의되고 결정되는지 가까이에서 지켜보는 <br />
                것만으로도 업무 역량에 큰 도움이 되었고 많은 보람을 느꼈습니다.<br />
                그리고, 기획팀에서는 수익/비용 기안 검토 및 예산 배정을 진행하기 때문에, 회사의 전반적인 현황과 디테일한 부분에 대해서 정확하게 알 수 <br />
                있게 되는 것도 일하면서 흥미롭고 보람되는 경험이라고 할 수 있습니다.<br />
                이 과정에서 제가 결재하고 예산 투입한 현업부서의 사업 등이 디벨롭되고, 성과 창출을 통해 회사의 손익에 기여를 할 때 더 큰 보람을 <br />
                느낍니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                콘텐츠를 좋아하는 MZ세대 입사지원자라면 모두 환영합니다. <br />
                꼭 방송 콘텐츠가 아니더라도, 콘텐츠에 대한 관심만 있다면, 입사 준비의 절반은 성공하였다고 생각합니다.<br />
                제 경험상 콘텐츠에 대한 지속적인 관심은 결국 본인이 하는 업무와도 연결되어 업무역량을 향상시켜주고, 업무를 하며 알게 된 다양한 <br />
                배경지식을 바탕으로 콘텐츠에 대한 관심도 더 증가한 것 같습니다.<br />
                이처럼 콘텐츠에 대한 관심은 업무와 선순환이 되며 회사 및 업무에 대한 만족도를 증가시킬 것이고, 본래 좋아하던 콘텐츠도 <br />
                더욱 좋아하게 되어 MZ세대가 원하는 덕업일치를 회사에서 충분히 얻어갈 수 있을 것이라 생각합니다. <br />
                다양한 콘텐츠를 좋아하는 후배 분들의 입사를 기다리고 있겠습니다.
                </p>
            </div>
        </div>);
}

export default Plan;

